import React from "react";
import { State } from "./State";
import { Action } from "./Actions";
import StoreContext from "./StoreContext";
import { ApiClient, ApiOrg, MessagesClient } from "lib/api";

export const useStore = (): [State, React.Dispatch<Action>] => {
  const { state, dispatch } = React.useContext(StoreContext);
  return [state, dispatch];
};

export const useApiClient = (): ApiClient => {
  const { state } = React.useContext(StoreContext);
  return state.apiClient;
};

export const useOrg = (): ApiOrg => {
  const { state } = React.useContext(StoreContext);
  if (!state.org) {
    throw new Error("Org not found");
  }
  return state.org;
};

export const useMessagesClient = (): MessagesClient => {
  const { state } = React.useContext(StoreContext);
  if (!state.messages) {
    throw new Error("Messages client not found");
  }
  return state.messages;
};
